<template>
  <v-container fluid>
    <v-progress-linear
      v-if="loading"
      class="mb-6"
      color="primary"
      indeterminate
    />

    <v-card v-else class="premium-card" elevation="10">
      <v-card-title class="primary white--text">
        <v-icon class="mr-2" color="white">mdi-truck-delivery</v-icon>
        Fornecedor
      </v-card-title>

      <v-card-text class="pt-6">
        <v-row dense>
          <v-col cols="12" md="4">
            <v-text-field
              label="Fornecedor"
              v-model="fields.Fornecedor"
              outlined
              dense
              readonly
              hide-details
              prepend-inner-icon="mdi-identifier"
              class="premium-field"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              label="Nome"
              v-model="fields.Nome"
              outlined
              dense
              readonly
              hide-details
              prepend-inner-icon="mdi-domain"
              class="premium-field"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              label="NIF (NumContrib)"
              v-model="fields.NumContrib"
              outlined
              dense
              readonly
              hide-details
              prepend-inner-icon="mdi-card-account-details-outline"
              class="premium-field"
            />
          </v-col>
        </v-row>

        <div v-if="!hasSupplier" class="empty-hint">
          Nenhum fornecedor selecionado.
        </div>
      </v-card-text>
    </v-card>

    <!-- Avaliações (só para super + supplier_evaluations.read) -->
    <v-card
      v-if="canSeeEvaluations && hasSupplier"
      class="premium-card mt-6"
      elevation="10"
    >
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2" color="primary">mdi-clipboard-text</v-icon>
        <span class="text-subtitle-1 font-weight-bold">Avaliações</span>

        <v-spacer />

        <!-- Se quiseres botão de criar (opcional) -->
        <v-btn
          v-if="$store.getters.hasPermission(['super', 'supplier_evaluations.write'])"
          color="primary"
          depressed
          @click="$router.push('/evaluations/create/' + fields.Fornecedor)"
        >
          <v-icon left>mdi-plus</v-icon>
          Nova avaliação
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <!-- Reaproveitar o teu Evaluations.vue -->
        <Evaluations :has_component="true" />
      </v-card-text>
    </v-card>

    <DialogSuccess :opened="success" @on-ok="onSuccess">
      Equipa gravada com sucesso
    </DialogSuccess>
  </v-container>
</template>

<script>
import DialogSuccess from "@/components/UI/DialogSuccess.vue";
import Evaluations from "@/views/supplier_evaluation/Evaluations.vue"; // ajusta o path se necessário

export default {
  name: "Supplier",
  components: { DialogSuccess, Evaluations },
  props: {
    method: String,
    supplier: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      success: false,
      fields: {
        Fornecedor: "",
        Nome: "",
        NumContrib: "",
      },
    };
  },
  computed: {
    hasSupplier() {
      return (
        !!this.supplier &&
        (this.supplier.Fornecedor || this.supplier.Nome || this.supplier.NumContrib)
      );
    },
    canSeeEvaluations() {
      // Mantive o teu padrão de permissões
      return this.$store.getters.hasPermission(["super", "supplier_evaluations.update.update"])
    },
  },
  mounted() {
    this.fillBaseData();
  },
  watch: {
    supplier: {
      handler() {
        this.fillBaseData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    fillBaseData() {
      this.loading = true;

      const s = this.supplier || {};
      this.fields.Fornecedor = s.Fornecedor || "";
      this.fields.Nome = s.Nome || "";
      this.fields.NumContrib = s.NumContrib || "";

      this.$nextTick(() => {
        this.loading = false;
      });
    },
    onSuccess() {
      this.success = false;
    },
  },
};
</script>

<style scoped>
.premium-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.premium-field :deep(.v-input__slot) {
  border-radius: 12px !important;
  background: linear-gradient(180deg, rgba(250, 250, 252, 1) 0%, rgba(245, 246, 250, 1) 100%);
}

.premium-field :deep(input) {
  cursor: default !important;
}

.empty-hint {
  margin-top: 14px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.55);
}
</style>
